import api from './axios';

export const fetchAppointments = (params) =>
  api.get('/appointments', { params }).then((r) => r.data);

export const fetchAppointmentSuggestions = (params) =>
  api.get('/appointments/suggestions', { params }).then((r) => r.data);

export const fetchAppointment = (id) =>
  api.get(`/appointments/${id}`).then((r) => r.data);

export const createAppointment = (body) =>
  api.post('/appointments', body).then((r) => r.data);

export const approveAppointment = (id) =>
  api.put(`/appointments/${id}/approve`).then((r) => r.data);

export const rejectAppointment = (id, cancellationReason) =>
  api.put(`/appointments/${id}/reject`, { cancellationReason }).then((r) => r.data);

export const assignAppointment = (id, body) =>
  api.put(`/appointments/${id}/assign`, body).then((r) => r.data);

export const proposeAppointmentSchedule = (id, body) =>
  api.put(`/appointments/${id}/schedule/propose`, body).then((r) => r.data);

export const respondToAppointmentSchedule = (id, body) =>
  api.put(`/appointments/${id}/schedule/respond`, body).then((r) => r.data);

export const respondToStaffProposal = (id, body) =>
  api.put(`/appointments/${id}/staff-proposal/respond`, body).then((r) => r.data);

export const checkStaffAvailability = (params) =>
  api.get('/appointments/staff-availability', { params }).then((r) => r.data);

export const respondToAssignment = (id, body) =>
  api.put(`/appointments/${id}/assignment/respond`, body).then((r) => r.data);

export const updateAppointmentStatus = (id, status, cancellationReason) =>
  api.put(`/appointments/${id}/status`, { status, cancellationReason }).then((r) => r.data);

export const cancelAppointment = (id, cancellationReason) =>
  updateAppointmentStatus(id, 'CANCELLED', cancellationReason);

export const sendChatMessage = (id, message) =>
  api.post(`/appointments/${id}/chat`, { message }).then((r) => r.data);

export const fetchSalonStaff = (params) =>
  api.get('/appointments/staff', { params }).then((r) => r.data);

export const adjustAppointmentPrice = (id, body) =>
  api.put(`/appointments/${id}/adjust-price`, body).then((r) => r.data);

export const uploadAppointmentPaymentSlip = (id, file, bankAccountId) => {
  const fd = new FormData();
  fd.append('file', file);
  if (bankAccountId) fd.append('bankAccountId', bankAccountId);
  return api
    .post(`/appointments/${id}/payment-slip`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);
};

export const verifyAppointmentPaymentSlip = (id, slipIndex) =>
  api.put(`/appointments/${id}/payment-slip/${slipIndex}/verify`).then((r) => r.data);
